import 'element-closest';

let convertToArray = function (nodeList) {
    return [].slice.call(nodeList);
}
let accordionLists: Array<any> = convertToArray(document.querySelectorAll('[data-accordion-list]'));
let resizeTimer;
const OPEN_CLASS = 'libaccordion-open-js';
const OPEN_CSS_CLASS = 'libaccordion-open';
class AccordionsOptions {
    singleAccordion: boolean = false;
}
export class Accordions {
    options: AccordionsOptions = new AccordionsOptions();
    constructor(private optArg?: any) {
        window.addEventListener('resize', () => {
            requestAnimationFrame(this.triggerSetAccordionHeights.bind(this));
        });

        for (let i = 0; i < accordionLists.length; ++i) {
            const accordionList = accordionLists[i];
            accordionList.addEventListener("click", this.accordionClick.bind(this), false);
        }

        //Check for Options
        if (this.optArg === undefined)
            this.optArg = new AccordionsOptions();
        else {
            this.options.singleAccordion = (this.optArg.singleAccordion === undefined) ? this.options.singleAccordion : this.optArg.singleAccordion;
        }
    }
    setAccordionHeights() {
        setTimeout(function () {
            for (let i = 0; i < accordionLists.length; ++i) {
                const accordionList = accordionLists[i];

                let openAccordions = accordionList.querySelectorAll('.' + OPEN_CLASS);
                if (openAccordions.length > 0) {

                    for (let j = 0; j < openAccordions.length; ++j) {
                        const openAccordion = openAccordions[j];
                        let accordionToReCalc = openAccordion.querySelector('[data-accordion-content-id]');
                        let accordionRecalcedHeight = accordionToReCalc.getBoundingClientRect().height;
                        openAccordion.style.height = accordionRecalcedHeight + 'px';
                    }
                }
            }

        }, 100);
    }
    accordionClick(e) {
        if (e.target !== e.currentTarget) {
            let accordionToOpenId = e.target.getAttribute('data-accordion-trigger');
            if (window["Element"] && !(Element.prototype as any).closest) {
                (Element.prototype as any).closest =
                    function (s) {
                        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                            i,
                            el = this;
                        do {
                            i = matches.length;
                            while (--i >= 0 && matches.item(i) !== el) { };
                        } while ((i < 0) && (el = el.parentElement));
                        return el;
                    };
            }
            if (accordionToOpenId === null) {
                accordionToOpenId = e.target.closest('[data-accordion-trigger]').getAttribute('data-accordion-trigger');
            }
            let accordionToToggle = document.querySelector('[data-accordion-id="' + accordionToOpenId + '"]');
            let accordionContentHeight = document.querySelector('[data-accordion-content-id="' + accordionToOpenId + '"]').getBoundingClientRect().height;
            if (this.options.singleAccordion) {
                this.closeOpenAccordions(accordionToToggle);
            }
            if (accordionToToggle.classList.contains(OPEN_CLASS)) {
                this.closeAccordion(accordionToToggle);
            }
            else {
                this.openAccordion(accordionToToggle, accordionContentHeight);
            }
            this.setAccordionHeights();
        }
        e.stopPropagation();
    }
    openAccordion(accordionToOpen, accordionToOpenHeight) {
        accordionToOpen.classList.add(OPEN_CLASS);
        accordionToOpen.setAttribute('style', 'height:' + accordionToOpenHeight + 'px');
        accordionToOpen.setAttribute('aria-hidden', 'false');
        accordionToOpen.parentElement.classList.add(OPEN_CSS_CLASS);
    }
    closeAccordion(accordionToClose) {
        accordionToClose.classList.remove(OPEN_CLASS);
        accordionToClose.setAttribute('style', 'height: 0px');
        accordionToClose.setAttribute('aria-hidden', 'true');
        accordionToClose.parentElement.classList.remove(OPEN_CSS_CLASS);
    }
    triggerSetAccordionHeights() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            this.setAccordionHeights();
        }, 100);
    }
    closeOpenAccordions(exception) {
        let openAccordions = convertToArray(document.querySelectorAll('.' + OPEN_CLASS));

        for (let i = 0; i < openAccordions.length; ++i) {
            const openAccordion = openAccordions[i];
            if (openAccordion !== exception) {
                this.closeAccordion(openAccordion);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./lib/lib-javascript/accordion/accordions.ts